<template>
  <div style="min-height: 20vh; width: 700px; margin: auto" class="py-4">
    <div class="heading h2 mb-2 text-center pb-4">No NPC editor data found!</div>

    NPC data are included with the paid version of the Lancer Core Book and are therefore not
    included with COMP/CON by default. You can find NPC Class, Template, and Feature data as
    additional downloadable content on the
    <a href="https://massif-press.itch.io/corebook-pdf" target="_blank">
      LANCER: Core Book itch.io page
    </a>
    .
    <br />
    <br />
    If you have already downloaded the NPC data, you can import it into COMP/CON via the Content
    Manager available on the Main Menu or in the Options menu on the right side of the nav bar.
    <br />
    <br />
    If you purchased a physical copy of the Lancer Core Book, but have not received instructions on
    how to redeem your copy of the digital version and its associated assets, including core NPC
    data, please contact Massif Press at
    <a href="mailto:massifpress@gmail.com">massifpress@gmail.com</a>
    .
  </div>
</template>

<script lang="ts">
export default {
  name: 'cc-missing-gm-lcp-text',
};
</script>
